import { render, staticRenderFns } from "./AddOfertaProductie.vue?vue&type=template&id=8ada5dfc"
import script from "./AddOfertaProductie.vue?vue&type=script&lang=js"
export * from "./AddOfertaProductie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports